<!--
  订单的添加 / 编辑 / 详情表单弹窗

  对照原型「订单--订单管理 - 新增表单」：
  · 双列布局（左列 / 右列），无流程条
  · 标题「订单管理」，底部「抄送给」+「保存」
  · 带 * 的必填项：产品 / 客户名称 / 甲方联系人 / 微信 / 服务 / 项目名称 / 联系手机 / 预计时间
  · 合同编号为灰底只读（由合同关联带出，不在本表单维护）
-->
<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="70%">
    <el-form
      v-loading="formLoading"
      ref="formRef"
      :class="{ 'crm-order-form--readonly': isDetail }"
      :model="formData"
      :rules="formRules"
      label-width="110px"
    >
      <el-row :gutter="20">
        <!-- ==================== 左列 ==================== -->
        <el-col :span="12">
          <el-form-item label="订单编号" prop="no">
            <el-input v-model="formData.no" disabled placeholder="保存后自动生成" />
          </el-form-item>
          <el-form-item label="产品" prop="productId">
            <el-select
              v-model="formData.productId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择产品"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="端口" prop="port">
            <el-input v-model="formData.port" :rows="2" placeholder="请输入端口" type="textarea" />
            <div class="crm-order-tip">
              端口是指打开方式，主要包含：app，小程序，公众号，H5，PC，客户端，其他
            </div>
          </el-form-item>
          <el-form-item label="客户名称" prop="customerId">
            <el-select
              v-model="formData.customerId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择客户"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="甲方联系人" prop="contactName">
            <el-input v-model="formData.contactName" placeholder="请输入甲方联系人" />
          </el-form-item>
          <el-form-item label="微信" prop="contactWechat">
            <el-input v-model="formData.contactWechat" placeholder="请输入微信" />
          </el-form-item>
          <el-form-item label="职务" prop="contactTitle">
            <el-input v-model="formData.contactTitle" placeholder="请输入职务" />
          </el-form-item>
          <el-form-item label="性别" prop="contactGender">
            <el-select
              v-model="formData.contactGender"
              class="w-1/1"
              clearable
              placeholder="请选择性别"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.SYSTEM_USER_SEX)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="省市区" prop="province">
            <el-cascader
              v-model="areaValue"
              :options="areaTree"
              :props="areaCascaderProps"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择省 / 市 / 区"
              @change="handleAreaChange"
            />
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="formData.address" placeholder="请输入详细地址" />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              :rows="2"
              placeholder="请输入备注"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="签约时间" prop="signTime">
            <el-date-picker
              v-model="formData.signTime"
              class="w-1/1"
              placeholder="请选择签约时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="生效日期" prop="effectDate">
            <el-date-picker
              v-model="formData.effectDate"
              class="w-1/1"
              placeholder="请选择生效日期"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="销售/商务" prop="salesUserId">
            <el-select
              v-model="formData.salesUserId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择销售 / 商务"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品经理" prop="productManagerId">
            <el-select
              v-model="formData.productManagerId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择产品经理"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="技术总监" prop="techDirectorId">
            <el-select
              v-model="formData.techDirectorId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择技术总监"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="ios开发" prop="iosDevId">
            <el-select
              v-model="formData.iosDevId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择 ios 开发"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="web前端" prop="webDevId">
            <el-select
              v-model="formData.webDevId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择 web 前端"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="小程序开发" prop="mpDevId">
            <el-select
              v-model="formData.mpDevId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择小程序开发"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开发技术要求" prop="devTechRequire">
            <el-input
              v-model="formData.devTechRequire"
              :rows="2"
              placeholder="请输入开发技术要求"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="自研、外包" prop="selfOutsource">
            <el-input v-model="formData.selfOutsource" placeholder="请输入自研 / 外包" />
          </el-form-item>
          <el-form-item label="相关文件" prop="relatedFiles">
            <UploadFile
              v-model="formData.relatedFiles"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
          <el-form-item label="系统账号信息" prop="accountInfo">
            <el-input
              v-model="formData.accountInfo"
              :rows="2"
              placeholder="请输入系统账号信息"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="原型链接" prop="prototypeLink">
            <el-input v-model="formData.prototypeLink" placeholder="请输入原型链接" />
          </el-form-item>
          <el-form-item label="第三方账号汇总" prop="thirdAccountSummary">
            <el-input
              v-model="formData.thirdAccountSummary"
              :rows="2"
              placeholder="请输入第三方账号汇总"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="交付资料" prop="deliveryMaterial">
            <UploadFile
              v-model="formData.deliveryMaterial"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
          <el-form-item label="进度" prop="progress">
            <el-select v-model="formData.progress" class="w-1/1" clearable placeholder="请选择进度">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_ORDER_PROGRESS)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="进度说明(%)" prop="progressPercent">
            <el-input-number
              v-model="formData.progressPercent"
              :max="100"
              :min="0"
              class="w-1/1"
              controls-position="right"
              placeholder="请输入进度说明"
            />
          </el-form-item>
          <el-form-item label="预计时间" prop="expectTime">
            <el-date-picker
              v-model="formData.expectTime"
              class="w-1/1"
              placeholder="请选择预计时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="成本核算" prop="costCheck">
            <el-input-number
              v-model="formData.costCheck"
              :min="0"
              :precision="2"
              class="w-1/1"
              controls-position="right"
              placeholder="请输入成本核算"
            />
          </el-form-item>
          <el-form-item label="项目进度表" prop="projectSchedule">
            <UploadFile
              v-model="formData.projectSchedule"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
        </el-col>

        <!-- ==================== 右列 ==================== -->
        <el-col :span="12">
          <el-form-item label="合同编号" prop="contractNo">
            <el-input v-model="formData.contractNo" disabled placeholder="由合同关联自动带出" />
          </el-form-item>
          <el-form-item label="服务" prop="service">
            <el-input
              v-model="formData.service"
              :rows="2"
              placeholder="请输入服务"
              type="textarea"
            />
            <div class="crm-order-tip">
              服务是指：标准化、二次开发、定制、设计、运营、其他服务
            </div>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="formData.projectName" placeholder="请输入项目名称" />
            <div class="crm-order-tip">项目名称：XX项目，PS：富圈圈员工福利平台</div>
          </el-form-item>
          <el-form-item label="联系手机" prop="contactMobile">
            <el-input
              v-model="formData.contactMobile"
              placeholder="请输入联系手机"
              @input="(v: string) => (formData.contactMobile = onlyDigits(v))"
            />
          </el-form-item>
          <el-form-item label="QQ" prop="contactQq">
            <el-input v-model="formData.contactQq" placeholder="请输入 QQ" />
          </el-form-item>
          <el-form-item label="邮箱" prop="contactEmail">
            <el-input v-model="formData.contactEmail" placeholder="请输入邮箱" />
          </el-form-item>
          <el-form-item label="行业" prop="industry">
            <el-select v-model="formData.industry" class="w-1/1" clearable placeholder="请选择行业">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_INDUSTRY)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="首款时间" prop="firstPaymentTime">
            <el-date-picker
              v-model="formData.firstPaymentTime"
              class="w-1/1"
              placeholder="请选择首款时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="交付日期" prop="deliveryDate">
            <el-date-picker
              v-model="formData.deliveryDate"
              class="w-1/1"
              placeholder="请选择交付日期"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="项目经理" prop="projectManagerId">
            <el-select
              v-model="formData.projectManagerId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择项目经理"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="交付经理" prop="deliveryManagerId">
            <el-select
              v-model="formData.deliveryManagerId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择交付经理"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设计负责人" prop="designOwnerId">
            <el-select
              v-model="formData.designOwnerId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择设计负责人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="安卓开发" prop="androidDevId">
            <el-select
              v-model="formData.androidDevId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择安卓开发"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="后端开发" prop="backendDevId">
            <el-select
              v-model="formData.backendDevId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择后端开发"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="测试负责人" prop="testOwnerId">
            <el-select
              v-model="formData.testOwnerId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择测试负责人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开发语言" prop="devLanguage">
            <el-input v-model="formData.devLanguage" placeholder="请输入开发语言" />
          </el-form-item>
          <el-form-item label="外包备注" prop="outsourceRemark">
            <el-input
              v-model="formData.outsourceRemark"
              :rows="2"
              placeholder="请输入外包备注"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="合同附件" prop="contractAttach">
            <UploadFile
              v-model="formData.contractAttach"
              class="min-w-80px"
              :use-material-library="false"
            />
            <div class="crm-order-tip crm-order-tip--danger">
              请上传合同附件，此处不要上传合同。合同附件主要是：需求说明、功能清单
            </div>
          </el-form-item>
          <el-form-item label="在线文档" prop="onlineDoc">
            <el-input v-model="formData.onlineDoc" placeholder="请输入在线文档链接" />
          </el-form-item>
          <el-form-item label="蓝湖链接" prop="lanhuLink">
            <el-input v-model="formData.lanhuLink" placeholder="请输入蓝湖链接" />
          </el-form-item>
          <el-form-item label="交付清单" prop="deliveryList">
            <el-input
              v-model="formData.deliveryList"
              :rows="2"
              placeholder="请输入交付清单"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="软著" prop="softwareCopyright">
            <UploadFile
              v-model="formData.softwareCopyright"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="formData.status" class="w-1/1" clearable placeholder="请选择状态">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_ORDER_STATUS)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="阶段" prop="stage">
            <el-select v-model="formData.stage" class="w-1/1" clearable placeholder="请选择阶段">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_ORDER_STAGE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="项目变更备注" prop="changeRemark">
            <el-input
              v-model="formData.changeRemark"
              :rows="2"
              placeholder="请输入项目变更备注"
              type="textarea"
            />
          </el-form-item>
          <el-form-item label="项目开发周期" prop="devCycle">
            <el-input v-model="formData.devCycle" placeholder="请输入项目开发周期" />
          </el-form-item>
          <el-form-item label="项目BUG汇总" prop="bugSummary">
            <el-input
              v-model="formData.bugSummary"
              :rows="2"
              placeholder="请输入项目 BUG 汇总"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">抄送与跟进</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="抄送给" prop="ccUserIds">
            <el-select
              v-model="ccUserIdList"
              class="w-1/1"
              clearable
              collapse-tags
              filterable
              multiple
              placeholder="请选择抄送人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="跟进方式" prop="followUpWay">
            <el-select
              v-model="formData.followUpWay"
              class="w-1/1"
              clearable
              placeholder="请选择跟进方式"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_FOLLOW_UP_TYPE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="跟进时间" prop="followUpTime">
            <el-date-picker
              v-model="formData.followUpTime"
              class="w-1/1"
              placeholder="请选择跟进时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开发汇总" prop="devSummary">
            <el-input v-model="formData.devSummary" placeholder="请输入开发汇总" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="跟进内容" prop="followUpContent">
            <el-input
              v-model="formData.followUpContent"
              :rows="2"
              placeholder="请输入跟进内容"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button v-if="!isDetail" :disabled="formLoading" type="primary" @click="submitForm">
        保 存
      </el-button>
      <el-button @click="dialogVisible = false">{{ isDetail ? '关 闭' : '取 消' }}</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { OrderApi } from '@/api/crm/order'
import * as AreaApi from '@/api/system/area'
import * as CustomerApi from '@/api/crm/customer'
import * as ProductApi from '@/api/crm/product'
import * as UserApi from '@/api/system/user'
import { onlyDigits } from '@/utils/inputFilter'
import { notPureNumber } from '@/utils/formRules'

defineOptions({ name: 'OrderForm' })

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗

const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中
const formType = ref('') // 表单的类型：create - 新增；update - 修改；detail - 详情
const customerList = ref<any[]>([]) // 客户下拉
const productList = ref<any[]>([]) // 产品下拉
const userOptions = ref<UserApi.UserVO[]>([]) // 用户下拉
const areaTree = ref<any[]>([]) // 地区树（一级 = 省）
const areaValue = ref<number[]>([]) // 省市区级联的选中值 [省, 市, 区]
const ccUserIdList = ref<number[]>([]) // 抄送人（多选，提交时转成逗号分隔字符串）
/** 详情模式：只读展示（原型无独立详情页） */
const isDetail = computed(() => formType.value === 'detail')
/** 省市区级联配置：emitPath = true，取回 [省编号, 市编号, 区编号] 后自行翻译成名称 */
const areaCascaderProps = { children: 'children', label: 'name', value: 'id', emitPath: true }

/**
 * 字符串型字段清单
 * ★ 必须初值为 ''，不能是 undefined：
 *   `UploadFile` 的 emitUpdateModelValue 只在 `isString(props.modelValue)` 时才把结果拼成
 *   逗号串，modelValue 为 undefined/null 且 limit !== 1 时会回传**数组**，
 *   提交给后端 String 字段将反序列化失败。
 *   对应后端 21 个 TEXT 列（MySQL 5.7 的 TEXT 不允许 DEFAULT，可能返回 null），
 *   故详情回填时也要用 normalizeStrings 归一。
 */
const STRING_FIELDS = [
  'no',
  'service',
  'projectName',
  'port',
  'contactName',
  'contactMobile',
  'contactWechat',
  'contactTitle',
  'contactQq',
  'contactEmail',
  'province',
  'city',
  'district',
  'address',
  'remark',
  'selfOutsource',
  'outsourceRemark',
  'devLanguage',
  'relatedFiles',
  'accountInfo',
  'prototypeLink',
  'thirdAccountSummary',
  'deliveryMaterial',
  'projectSchedule',
  'contractAttach',
  'onlineDoc',
  'lanhuLink',
  'deliveryList',
  'softwareCopyright',
  'progressDesc',
  'contractNo',
  'changeRemark',
  'devCycle',
  'bugSummary',
  'followUpContent',
  'devSummary',
  'ccUserIds'
]

/** 把后端返回的 null / undefined 字符串字段归一为 '' */
const normalizeStrings = (data: Record<string, any>) => {
  STRING_FIELDS.forEach((key) => {
    if (data[key] === null || data[key] === undefined) {
      data[key] = ''
    }
  })
  return data
}

/** 空表单数据 */
const emptyFormData = () => ({
  id: undefined,
  no: '',
  customerId: undefined,
  productId: undefined,
  service: '',
  projectName: '',
  port: '',
  contactName: '',
  contactMobile: '',
  contactWechat: '',
  contactTitle: '',
  contactGender: undefined,
  contactQq: '',
  contactEmail: '',
  province: '',
  city: '',
  district: '',
  address: '',
  industry: undefined,
  remark: '',
  signTime: undefined,
  effectDate: undefined,
  firstPaymentTime: undefined,
  deliveryDate: undefined,
  salesUserId: undefined,
  productManagerId: undefined,
  techDirectorId: undefined,
  iosDevId: undefined,
  webDevId: undefined,
  mpDevId: undefined,
  projectManagerId: undefined,
  deliveryManagerId: undefined,
  designOwnerId: undefined,
  androidDevId: undefined,
  backendDevId: undefined,
  testOwnerId: undefined,
  devTechRequire: '',
  selfOutsource: '',
  outsourceRemark: '',
  devLanguage: '',
  relatedFiles: '',
  accountInfo: '',
  prototypeLink: '',
  thirdAccountSummary: '',
  deliveryMaterial: '',
  projectSchedule: '',
  contractAttach: '',
  onlineDoc: '',
  lanhuLink: '',
  deliveryList: '',
  softwareCopyright: '',
  progress: 1, // 原型默认「需求确认」
  progressPercent: 0, // 原型默认 0%
  progressDesc: '',
  expectTime: undefined,
  costCheck: undefined,
  status: 1, // 原型默认「待执行」
  stage: undefined,
  contractNo: '',
  changeRemark: '',
  devCycle: '',
  bugSummary: '',
  followUpWay: undefined,
  followUpContent: '',
  devSummary: '',
  followUpTime: undefined,
  starred: undefined,
  topped: undefined,
  ccUserIds: ''
})

const formData = ref<any>(emptyFormData())
const formRules = reactive({
  productId: [{ required: true, message: '产品不能为空', trigger: 'change' }],
  customerId: [{ required: true, message: '客户名称不能为空', trigger: 'change' }],
  contactName: [
    { required: true, message: '甲方联系人不能为空', trigger: 'blur' },
    notPureNumber('甲方联系人')
  ],
  contactWechat: [{ required: true, message: '微信不能为空', trigger: 'blur' }],
  service: [{ required: true, message: '服务不能为空', trigger: 'blur' }],
  projectName: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
  contactMobile: [{ required: true, message: '联系手机不能为空', trigger: 'blur' }],
  expectTime: [{ required: true, message: '预计时间不能为空', trigger: 'change' }]
})
const formRef = ref() // 表单 Ref

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  formType.value = type
  dialogTitle.value = getDialogTitle(type)
  resetForm()
  // 加载下拉数据
  customerList.value = await CustomerApi.getCustomerSimpleList()
  productList.value = await ProductApi.getProductSimpleList()
  userOptions.value = await UserApi.getSimpleUserList()
  areaTree.value = await AreaApi.getAreaTree()
  // 修改 / 详情时，加载数据
  if (id) {
    formLoading.value = true
    try {
      const data = await OrderApi.getOrder(id)
      // 先合并再归一：后端 TEXT 列可能返回 null，直接展开会覆盖空表单里的 ''
      formData.value = normalizeStrings({ ...emptyFormData(), ...data })
      ccUserIdList.value = parseUserIds(data.ccUserIds)
      areaValue.value = findAreaIds(data.province, data.city, data.district)
    } finally {
      formLoading.value = false
    }
  }
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 弹窗标题 */
const getDialogTitle = (type: string) => {
  if (type === 'create') {
    return '新增订单'
  }
  return type === 'detail' ? '订单详情' : '编辑订单'
}

/** 「1,2」→ [1, 2] */
const parseUserIds = (userIds?: string): number[] => {
  if (!userIds) {
    return []
  }
  return userIds
    .split(',')
    .map((item) => Number(item))
    .filter((item) => !isNaN(item))
}

/** 在地区树中按编号查找名称 */
const getAreaName = (id?: number): string | undefined => {
  if (!id) {
    return undefined
  }
  const stack = [...areaTree.value]
  while (stack.length > 0) {
    const node = stack.shift()
    if (node.id === id) {
      return node.name
    }
    if (node.children) {
      stack.push(...node.children)
    }
  }
  return undefined
}

/** 省市区级联变化：把编号翻译成名称（后端存名称） */
const handleAreaChange = (ids?: number[]) => {
  formData.value.province = ids && ids.length > 0 ? getAreaName(ids[0]) : undefined
  formData.value.city = ids && ids.length > 1 ? getAreaName(ids[1]) : undefined
  formData.value.district = ids && ids.length > 2 ? getAreaName(ids[2]) : undefined
}

/** 按省市区名称反查级联的编号路径（用于回显） */
const findAreaIds = (province?: string, city?: string, district?: string): number[] => {
  if (!province) {
    return []
  }
  const provinceNode = areaTree.value.find((item) => item.name === province)
  if (!provinceNode) {
    return []
  }
  const cityNode = (provinceNode.children || []).find((item: any) => item.name === city)
  if (!cityNode) {
    return [provinceNode.id]
  }
  const districtNode = (cityNode.children || []).find((item: any) => item.name === district)
  return districtNode
    ? [provinceNode.id, cityNode.id, districtNode.id]
    : [provinceNode.id, cityNode.id]
}

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  await formRef.value.validate()
  // 提交请求
  formLoading.value = true
  try {
    const data = { ...formData.value }
    data.ccUserIds = ccUserIdList.value.length > 0 ? ccUserIdList.value.join(',') : undefined
    if (formType.value === 'create') {
      await OrderApi.createOrder(data)
      message.success(t('common.createSuccess'))
    } else {
      await OrderApi.updateOrder(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = emptyFormData()
  ccUserIdList.value = []
  areaValue.value = []
  formRef.value?.resetFields()
}
</script>

<style lang="scss" scoped>
.crm-order-tip {
  color: var(--el-text-color-secondary);
  font-size: 12px;
  line-height: 18px;
}

.crm-order-tip--danger {
  color: var(--el-color-danger);
}

/** 详情模式：整表只读 */
.crm-order-form--readonly {
  pointer-events: none;
}
</style>
